$(document).ready( function() {
    initAccordion();
    initMobileAccordion();
});

function initAccordion() {
    if (!$('.misc-container .content').hasClass('accordion')) {
        return;
    }

    $(document).click( '.misc-container .section-title', function(evt) {
        var $this = $(evt.target);
        var $section = $this.closest('.section');
        $section.toggleClass('active');
    })
}

function initMobileAccordion() {
    if (!$('.misc-container .content').hasClass('mobile-accordion')) {
        return;
    }

    $(document).click( '.misc-container .section-title', function(evt) {
        if ($(window).width() > 767) {
            return;
        }
        var $this = $(evt.target);
        var $section = $this.closest('.section');
        $section.toggleClass('active');
    })
}